import React, {Component} from 'react';
import { connect } from 'react-redux';
import UserInformation from './user-information';
import CommitteeInformation from './committee-information';
import UpdateInfo from './update-information';
import {next_page} from '../actions';
import '../global';
class UpdateContainer extends Component{

	render(){
		if(getPasswordSkip() === 'true'){
			this.props.next_page('user-information');
		}
		return (<div class="two-col-content-panel my-account">
					<div className="col-xs-12">
						<UserInformation/>
						<CommitteeInformation/>
						<UpdateInfo/>
					</div>
			</div>);
	}


}

export default connect (null, {next_page})(UpdateContainer);